import React from 'react'
import { Stack, Typography } from '@mui/material'
import logoPng from 'assets/logo.png'
import { grey } from '@mui/material/colors'
import { useNavigate } from 'react-router-dom'


export const AppHeader = () => {
  const navigate = useNavigate()

  return (
    <Stack direction={'row'} sx={{height: 50, backgroundColor: '#F2EEE8', width: '100%', borderBottom: '1px solid #bdbdbd'}} pl={3}  alignItems={'center'} justifyContent={'start'}>
      <img src={logoPng} height={28} style={{objectFit: 'contain'}}  />
      <Typography
        ml={3}
        fontSize={24}
        color={grey[800]}
        fontFamily={'"Times New Roman", "YuMincho", "Hiragino Mincho ProN", "Yu Mincho", "MS PMincho", serif;'}
        fontWeight={'bold'}
        pt={'3px'}
        sx={{textShadow: '1px 1px 1px rgba(0, 0, 0, 0.3)'}}
      >
        {'水害スコアリングシート'}
      </Typography>
    </Stack>
  )
}
